import type { AccommodationFacilityType } from "../../../../__generated__/gql/graphql";

export type BuildReserveUrlInput = {
  /** エリアの slug (必須)。 nuqs 側 area filter に渡る。 */
  areaSlug: string;
  /**
   * 建築タイプの seriesShortName の配列。
   * nuqs 側 architectureType filter (?arch=A&arch=B) にそのまま渡る。
   * 空 / 未指定なら arch パラメータを付けない。
   */
  archValues?: readonly string[];
  /**
   * 施設タイプ enum の配列。
   * nuqs 側 facility filter (?facility-filter=A-B) にハイフン結合で渡る。
   * 空 / 未指定なら facility-filter パラメータを付けない。
   */
  facilityTypes?: readonly AccommodationFacilityType[];
};

/**
 * エリア / 拠点 / 部屋タイプページの CTA から /go/reserve へ渡す URL を組み立てる。
 * form 側 (`useAreaFilter` / `useArchitectureTypeFilter` / `useFacilityFilter`) の
 * URL パラメータ仕様と一致させる。
 */
export function buildReserveUrl(input: BuildReserveUrlInput): string {
  const params = new URLSearchParams();
  params.append("area", input.areaSlug);
  for (const arch of input.archValues ?? []) {
    params.append("arch", arch);
  }
  const facilities = input.facilityTypes ?? [];
  if (facilities.length > 0) {
    params.set("facility-filter", facilities.join("-"));
  }
  return `/go/reserve?${params.toString()}`;
}
